import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { StyledPriceWithCurrency } from "./price-with-currency.scss";
const PriceWithCurrency = ({ price, currency, currencySign, className })=>{
    return /*#__PURE__*/ _jsxs(StyledPriceWithCurrency, {
        className: "price-with-currency",
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: "currency-sign-and-text",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classNames("currency-sign-with-text", className),
                        children: currencySign
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classNames("currency-text", className),
                        children: currency.toUpperCase()
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: className,
                children: price
            })
        ]
    });
};
export default PriceWithCurrency;
